import mirage from '../elements/mirage.js';
mirage.register();
